/**
 * Created by Konstantino on 29/9/16.
 */
'use strict';

angular.module('meanApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('income', {
        url: '/income/:clientId',
        params: {
          clientId: {
            value: null,
            squash: false
          }
        },
        templateUrl: 'app/income/income.html',
        controller: 'factfind-2-controller',
        authenticate: ['user','admin']
      });
  });
